import React from "react";
import { Box, Typography } from "@mui/material";

const TechSoftFooter: React.FC = () => {
  const handleTechSoftClick = () => {
    window.open("https://www.instagram.com/techsoft.tecnologia/", "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Desenvolvido por
      </Typography>
      <Box
        onClick={handleTechSoftClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          borderRadius: 1,
          padding: "4px 8px",
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
          },
        }}
      >
        <Typography variant="body2" fontWeight="bold" color="primary.main">
          TechSoft
        </Typography>
        <Box
          component="img"
          src="/techsoft1.jpg"
          alt="TechSoft"
          sx={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            border: "2px solid rgba(25, 118, 210, 0.3)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        />
      </Box>
    </Box>
  );
};

export default TechSoftFooter;
